import React from 'react';
import { toKebabCase } from '../../utils/utilities';
import { useSmoothScrollToHash } from '../../hooks/useSmoothScrollToHash';

const Heading = ({
  children,
  id: idProp,
  level = 2,
  ...props
}: {
  children: React.ReactNode;
  id?: string;
  level?: 1 | 2 | 3 | 4 | 5 | 6;
} & React.HTMLAttributes<HTMLHeadingElement>) => {
  let id = idProp;

  if (typeof children === 'string') {
    id = idProp ?? toKebabCase(children);
  }

  const scrollTargetRef = useSmoothScrollToHash(`#${id}`);

  const HeadingTag = `h${level}` as keyof React.JSX.IntrinsicElements;
  return React.createElement(HeadingTag, { id, ref: scrollTargetRef, ...props }, children);
};

export default Heading;
